<template>
  <div class="customer-notice">
    <HeroBanner
      :background-image="bannerImage"
      title="공지사항"
      sub-title="다비치 히어링 보청기의 주요 소식과 <br>이벤트 내용을 안내합니다."
    />
    <BoardList
      :boards="boards"
      detail-path="/customer/notice"
      :show-search="true"
      :show-more-button="hasMore"
      :loading="loading"
      @search="handleSearch"
      @load-more="loadMoreBoards"
    />
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import BoardList from "@/components/BoardList.vue";
import bannerBg from "@/assets/images/heros/06-top-img.png";
import bannerBg2x from "@/assets/images/heros/06-top-img@2x.png";
import boardListMixin from '@/mixins/boardListMixin';
import { fetchNewsAndNoticeList } from '@/api';

export default {
  name: 'CustomerNotice',
  components: {HeroBanner, BoardList},
  mixins: [boardListMixin],
  data() {
    return {
      bannerImage: [bannerBg, bannerBg2x],
      boardPath: '/customer/notice' // boardListMixin에서 사용
    };
  },
  methods: {
    /**
     * API 호출 함수 (mixin에서 사용)
     * - mixin의 loadBoards에서 호출됨
     */
    async fetchAPI(params) {
      const response = await fetchNewsAndNoticeList(params);
      // dispYn 값이 'Y'인 항목만 필터링
      console.log(response.data);
      if (response.data && Array.isArray(response.data)) {
        response.data = response.data.filter(item => item.disp_yn === 'Y');
      }
      return response;
    }
  }
};
</script>

<style scoped lang="scss">
.customer-notice {
  width: 100%;
  min-height: 55px;
}
</style>